import React, { Component } from "react"
import EscapeOutside from "react-escape-outside"

import "./MDOManageModal.styles.scss"
import ViewMain from "./components/ViewMain/ViewMain"
import ViewLog from "./components/ViewLog/ViewLog"
import ViewEdit from "./components/ViewEdit/ViewEdit"
import ViewReplace from "./components/ViewReplace/ViewReplace"
import ViewDeactivate from "./components/ViewDeactivate/ViewDeactivate"

import close_green_corner from "./_image/close_green_corner.svg"
import close_button from "./_image/close_button.svg"

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={handleClose}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  )
}

class MDOManageModal extends Component {
  state = {
    show: false,

    view_main: true,
    view_edit: false,
    view_log: false,
    view_replace: false,
    view_deactivate: false,

    dummy_data: {
      image:
        "https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png",
    },
  }

  handleClick = () => {
    document.getElementById("uploadimage").click()
  }

  handleImageChange = (event) => {
    const fileUploaded = event.target.files[0]
    this.setState({
      image: fileUploaded.name,
    })
  }

  hideModal = () => {
    this.setState({ show: false })
  }
  viewLogOnClick = () => {
    this.setState({
      ...this.state,
      view_log: true,
      view_main: false,
      view_edit: false,
      view_replace: false,
      view_deactivate: false,
    })
  }
  viewMainOnClick = () => {
    this.setState({
      ...this.state,
      view_main: true,
      view_log: false,
      view_edit: false,
      view_replace: false,
      view_deactivate: false,
    })
  }
  viewEditOnClick = () => {
    this.setState({
      ...this.state,
      view_edit: true,
      view_log: false,
      view_main: false,
      view_replace: false,
      view_deactivate: false,
    })
  }
  viewReplaceOnClick = () => {
    this.setState({
      ...this.state,
      view_replace: true,
      view_edit: false,
      view_log: false,
      view_main: false,
      view_deactivate: false,
    })
  }

  viewDeactivateOnClick = () => {
    this.setState({
      ...this.state,
      view_log: false,
      view_main: false,
      view_edit: false,
      view_replace: false,
      view_deactivate: true,
    })
  }

  render() {
    // const {
    //   name,
    //   id,
    //   contact_number,
    //   employee_id,
    //   image,
    //   fse,
    //   leave_day,
    //   status,
    //   spot_codes,
    // } = this.props.data

    return (
      <section className="mdomanagment-section">
        <Modal show={this.props.show} handleClose={this.hideModal}>
          <div className="modal-header">
            {this.state.view_main && (
              <div className="headline">
                <div className="main-headline">Manage MDO</div>
                <div className="sub-headline">You can alter details</div>
              </div>
            )}
            {this.state.view_log && (
              <div className="headline">
                <div className="main-headline">Account Log</div>
                <div className="sub-headline">History of Changes</div>
              </div>
            )}
            {this.state.view_edit && (
              <div className="headline">
                <div className="main-headline">Edit MDO</div>
                <div className="sub-headline">
                  Fill in the details and press Submit
                </div>
              </div>
            )}
            {this.state.view_replace && (
              <div className="headline">
                <div className="main-headline">Replace MDO</div>
                <div className="sub-headline">Assign the spots to others</div>
              </div>
            )}
            {this.state.view_deactivate && (
              <div className="headline">
                <div className="main-headline">Deactivate an MDO</div>
                <div className="sub-headline">
                  Please provide their resignation date here
                </div>
              </div>
            )}
            <div
              className="close-button-corner"
              onClick={this.props.handleHide}
            >
              <img className="corner" src={close_green_corner} alt="close" />
              <img className="cross" src={close_button} alt="close" />
              {/* <button className="button--close" onClick={this.props.handleHide}>
                X
              </button> */}
            </div>
          </div>
          {this.state.view_main && (
            <ViewMain
              data={this.props.data}
              viewReplaceOnClick={this.viewReplaceOnClick}
              viewMainOnClick={this.viewMainOnClick}
              viewLogOnClick={this.viewLogOnClick}
              viewEditOnClick={this.viewEditOnClick}
              viewDeactivateOnClick={this.viewDeactivateOnClick}
              handleSave={this.props.handleSave}
            />
          )}
          {this.state.view_deactivate && (
            <ViewDeactivate
              data={this.props.data}
              viewReplaceOnClick={this.viewReplaceOnClick}
              viewMainOnClick={this.viewMainOnClick}
              viewLogOnClick={this.viewLogOnClick}
              viewEditOnClick={this.viewEditOnClick}
              handleSave={this.props.handleSave}
            />
          )}
          {this.state.view_log && (
            <ViewLog
              data={this.props.data}
              viewLogOnClick={this.viewLogOnClick}
              viewMainOnClick={this.viewMainOnClick}
            />
          )}
          {this.state.view_edit && (
            <ViewEdit
              data={this.props.data}
              viewMainOnClick={this.viewMainOnClick}
              viewEditOnClick={this.viewEditOnClick}
              handleSave={this.props.handleSave}
            />
          )}
          {this.state.view_replace && (
            <ViewReplace
              data={this.props.data}
              viewMainOnClick={this.viewMainOnClick}
              viewReplaceOnClick={this.viewReplaceOnClick}
              handleSave={this.props.handleSave}
            />
          )}
        </Modal>
      </section>
    )
  }
}

export default MDOManageModal
